<template>
  <div id="corsi">
    <template>
      <v-card>
        <!--{{ this.$store.state.iscrizione.dati.flagOspite }}-->
        <v-card-title>
          <b>{{ $t("corsi['" + tabella + "']") }}</b>
          <span class="ma-3" v-if="false">
            {{ $t("corsi.sem1") }}
          </span>
          <span class="ma-3" v-if="this.parametri.semestre == 2">
            {{ $t("corsi.sem2") }}
          </span>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('corsi.ricerca')"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :no-results-text="corsoNonPresente"
          :loading="stato_caricamento"
          :loading-text="$t('corsi.preparazione')"
          :headers="colonnnefiltrate"
          group-by="ordine"
          sort-by="sigla"
          v-model:
          elencocorsi
          :items="corsi_dinamici"
          :search="search"
          :items-per-page="5"
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'navigate_before',
            nextIcon: 'navigate_next',

            disableItemsPerPage: true,
          }"
        >
          <template v-slot:group.header="{ items, isOpen, toggle }">
            <th colspan="100%">
              <p class="h5">
                <v-icon @click="toggle"
                  >{{ isOpen ? "remove" : "add" }}
                </v-icon>
                {{ items[0].categoria }}
              </p>
            </th>
          </template>

          <template #footer.page-text="props">
            {{ props.pageStart }}-{{ props.pageStop }} {{ $t("corsi.di") }}
            {{ props.itemsLength }}
          </template>

          <template v-slot:item.controls="item">
            <b> {{ item.sigla }}</b>
          </template>

          <template v-slot:item.controls="props">
            <!--<button v-if="props.item.name!='Eclair'" type="button" class="btn" style="background-color: rgb(231, 76, 60); border-color: rgb(231, 76, 60); color: white"
        @click="selezione(props.item)">
        Aggiungi</button>-->

            <button
              v-if="!props.item.selezionabile"
              type="button"
              class="btn btn-action primary darken-1 white--text"
              @click="checkCorso(props.item)"
            >
              {{ $t("corsi.aggiungi") }}
            </button>
            <span v-if="props.item.selezionabile" class="badge badge-danger"
              ><b>{{ props.item.testo_selezionabile }}</b></span
            >
            <p
              v-if="props.item.testo_selezionabile == 'OBBLIGATORIO'"
              v-tooltip="$t('corsi.obbligatori')"
              class="material-icons"
            >
              info
            </p>
          </template>

          <template v-slot:no-data>
            <v-alert text prominent type="error" icon="feedback">
              {{
                $t("corsi.nocorsi", {
                  tipocorso: $t("corsi['" + tabella + "']"),
                })
              }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
      <br />
      <div
        class="form-check pa-1"
        v-if="this.$store.state.iscrizione.dati.flagOspite"
      >
        <label class="form-check-label">
          <input
            v
            class="form-check-input"
            type="checkbox"
            value=""
            @click="filtro_corsi"
            v-model="checked"
          />
          <strong class="black--text text--lighten-1">{{
            $t("corsi.tuttiCorsi")
          }}</strong>
          <span class="form-check-sign">
            <span class="check"></span>
          </span>
        </label>
      </div>
    </template>
  </div>
</template>

<script>
import api from "@/services/EventService.js";

export default {
  props: {
    //['dati'],
    tabella: String,
  },
  methods: {
    filtro_corsi() {
      if (this.checked == true) {
        this.corsi_dinamici = this.corsi.filter(
          (c) =>
            c.FACOLTA == this.iscrizione.dati.fac_scelta.CODICENU ||
            c.FACOLTA == 0
        );
      } else {
        this.corsi_dinamici = this.corsi;
      }
    },

    async caricaCorsi() {
      /*     if(this.rinnovorichiesto.ciclo.log_tipo_iscrizione=='RINNOVO')
              {
                axios.get('/'+this.tabella+'/statutario/'+this.rinnovorichiesto.ciclo.cod_indirizzolaurea+'/'+this.rinnovorichiesto.ciclo.STATUTARIO+'/'+this.rinnovorichiesto.ciclo.annocorsonuovo+'/'+this.rinnovorichiesto.ciclo.SEMESTRE+'/'+this.rinnovorichiesto.ciclo.annoaccademiconuovo+'').then((r) => {
                        this.stato_caricamento = false
                        this.corsi = r.data
                        this.corsi_dinamici = this.corsi.filter(c => c.FACOLTA == this.rinnovorichiesto.ciclo.cod_facolta  || c.FACOLTA == 0)
                    }).catch((err) => {alert(err)})
              }
              else
              {*/
      this.corsi_dinamici = [];
      this.stato_caricamento = true;
      api
        .get(
          "/" +
            this.tabella +
            "/" +
            this.parametri.annoaccademico +
            "/" +
            this.iscrizione.dati.spec_scelta.CODICENU +
            "/" +
            this.iscrizione.dati.anno_scelto +
            "/" +
            this.parametri.semestre +
            ""
        )
        .then((r) => {
          this.stato_caricamento = false;
          this.corsi = r.data;
          this.corsi_dinamici = this.corsi.filter(
            (c) =>
              c.FACOLTA == this.iscrizione.dati.fac_scelta.CODICENU ||
              c.FACOLTA == 0
          );
        })
        .catch((err) => {
          alert(err);
        });
      //}
    },

    checkCorso: function(dati) {
      // controllo num max corsi selezionabili
      var flag = true;

      switch (this.tabella) {
        case "corsi":
          if (this.TotCorsi >= this.limiteCorsi.corsi.max) {
            // avviso

            this.$swal({
              title: this.$t("corsi.attenzione"),
              icon: "error",
              text: this.$t("corsi.maxCorsi"),
              type: "error",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary",
            }).then(() => {});

            //
            flag = false;
          }
          break;

        case "seminari":
          if (this.TotSeminari >= this.limiteCorsi.seminari.max) {
            // avviso

            this.$swal({
              title: this.$t("corsi.attenzione"),
              icon: "error",
              text: this.$t("corsi.maxSeminari"),
              type: "error",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary",
            }).then(() => {});

            //
            flag = false;
          }
          break;
        case "letture":
          if (this.TotLetture >= this.limiteCorsi.letture.max) {
            // avviso

            this.$swal({
              title: this.$t("corsi.attenzione"),
              icon: "error",
              text: this.$t("corsi.maxLetture"),
              type: "error",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary",
            }).then(() => {});

            //
            flag = false;
          }
          break;
      }
      // fine controllo
      if (flag) {
        this.checkPostiCorso(dati);
      }
    },

    checkPostiCorso(dati) {
      // check posti disponibili per i corsi chiusi

      api
        .get(
          "checkAddCorso/posti/" +
            this.parametri.annoaccademico +
            "/" +
            dati.corso
        )
        .then((r) => {
          if (r.data == "KO") {
            this.$swal({
              title: this.$t("corsi.attenzione"),
              icon: "error",
              text: "Il corso " + dati.sigla + " non ha più posti disponibili",
              type: "error",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-error",
            }).then(() => {});
          } else {
            this.selezione(dati);
          }
        })
        .catch((err) => {
          alert("Check_posti:" + err);
        });

      // alert('/checkAddCorso/'+dati.corso+'/'+this.rinnovorichiesto.ciclo.MATRICOL+'/'+this.rinnovorichiesto.ciclo.cod_corsolaurea)
      // se tutto ok vadu su selezione
    },

    selezione: function(dati) {
      //const flag =  this.$store.state.corsi_selezionati.find( h => h.sigla === dati.sigla);

      var flag = false;
      var arrCorsiScelti = this.corsiScelti;

      switch (this.tabella) {
        case "corsi":
          flag = arrCorsiScelti.corsi.find((h) => h.sigla === dati.sigla);

          break;
        case "seminari":
          flag = arrCorsiScelti.seminari.find((h) => h.sigla === dati.sigla);
          break;
        case "letture":
          flag = arrCorsiScelti.letture.find((h) => h.sigla === dati.sigla);
          break;
      }

      if (!flag) {
        //this.$store.commit("insertCorso", dati);
        this.$store.dispatch("insertCorso", {
          tabella: this.tabella,
          dati: dati,
        });
        /* switch (this.tabella) {
          case "corsi":
            this.$store.commit("aggiungicorso", dati);
            break;
          case "seminari":
            this.$store.commit("aggiungiseminario", dati);
            break;
          case "letture":
            this.$store.commit("aggiungilettura", dati);
            break;
        }*/

        this.$toasted.show(
          //"Il corso &nbsp;<b>" + dati.sigla + "</b>&nbsp; è stato aggiunto!",
          this.$t("corsi.aggiunto", { corso: dati.sigla }),
          {
            theme: "toasted-primary",
            position: "bottom-center",
            duration: 3000,
          }
        );
        //
      } else {
        this.$toasted.show(this.$t("corsi.giaScelto", { corso: dati.sigla }), {
          theme: "outline",
          position: "bottom-center",
          duration: 3000,
        });
      }
    },
  },
  data() {
    return {
      checked: false,
      elencocorsi: null,
      stato_caricamento: true,
      search: "",
      headers: [
        { text: "codice", value: "corso" },
        { text: "Corso", value: "sigla" },
        { text: "Semestre", value: "semestre" },
        { text: "Docente", value: "docente" },
        { text: "Descrizione", value: "descrizione" },
        { text: "", value: "controls" },
      ],
      corsi: [],
      corsi_dinamici: [],
    };
  },
  computed: {
    corsoNonPresente() {
      let testo = this.$t("corsi.nonTrovato1Sem");
      if (this.parametri.semestre == 2) {
        testo = this.$t("corsi.nonTrovato2Sem");
      }
      return testo;
    },
    colonnnefiltrate() {
      return this.headers.filter((header) => header.text !== "codice");
    },
    iscrizione: {
      get: function() {
        return this.$store.state.iscrizione;
      },
    },
    corsiScelti() {
      return this.$store.state.corsiscelti;
    },

    parametri() {
      return this.$store.state.parametri;
    },
    limiteCorsi() {
      return this.$store.state.corsiscelti.limiti;
    },
    TotCorsi() {
      return this.$store.getters.totaleCorsiScelti;
    },
    TotSeminari() {
      return this.$store.getters.totaleSeminariScelti;
    },
    TotLetture() {
      return this.$store.getters.totaleLettureScelti;
    },
  },
  mounted: function() {
    this.caricaCorsi();
  },
  activated() {
    this.caricaCorsi();
  },
};
</script>

<style>
.v-data-footer__select {
  display: none !important;
}
</style>
